module.exports = __webpack_public_path__ + "static/media/bgi-target-user.525b37f3.png";